import { render, staticRenderFns } from "./LanceMinimo.vue?vue&type=template&id=431196b6&"
import script from "./LanceMinimo.vue?vue&type=script&lang=js&"
export * from "./LanceMinimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports